import AppState from '../state';

export const getUserReferrer = (state: AppState): string | undefined => {
  return (
    state.auth.user?.attributes?.["custom:signup_source"] || undefined
  );
};